import JsonLd from '@/components/JsonLd'
import { serviceSchema, breadcrumbSchema } from '@/lib/jsonLdSchemas'
import Navbar from '@/components/layout/Navbar'
import Footer from '@/components/layout/Footer'
import AutomationHero from '@/components/sections/automation/AutomationHero'
import AutomationServices from '@/components/sections/automation/AutomationServices'
import AutomationPricing from '@/components/sections/automation/AutomationPricing'
import AutomationContact from '@/components/sections/automation/AutomationContact'
import ServiceNav from '@/components/sections/ServiceNav'

export default function Automation() {
  return (
    <div className="min-h-screen bg-background font-sans text-foreground selection:bg-accent selection:text-white">
      <JsonLd data={serviceSchema({ name: 'AI Automation', description: "Workflows and copilots that 10x your team's output. Automate the mundane so your team can focus on high-leverage work.", path: '/automation' })} />
      <JsonLd data={breadcrumbSchema([{ name: 'Services', path: '/#services' }, { name: 'Automation', path: '/automation' }])} />
      <Navbar />
      <main>
        <AutomationHero />
        <AutomationServices />
        <AutomationPricing />
        <AutomationContact />
        <ServiceNav />
      </main>
      <Footer />
    </div>
  )
}
